export default __webpack_public_path__ + "media/images/react_icons/exclamation_triangle-2cee9568f12b9bc5e234963d450d253c.svg";